import { BaseHub } from './base-hub';

export class SubscribeFavoritesHub extends BaseHub {
  public subscribe = () => {
    const methodName = 'subscribe-favorites';

    return this.hubConnection.invoke(methodName, false);
  };

  public unsubscribe = (topic: string) => {
    return this.hubConnection.invoke('unsubscribe', topic);
  };
}
